export default "__VITE_ASSET__BlR080XQ__"